import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '../../app/shared/loader/loader.service';
import {ToastrService} from 'ngx-toastr'
import { Router } from '@angular/router';
@Injectable()
export class HttpServiceInterceptor implements HttpInterceptor {

  private requests: HttpRequest<any>[] = [];
  constructor(private loaderService: LoaderService,private toster: ToastrService,private router: Router) { }
  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
        this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
}
private tokenExpired() {
 
  var decrpyt=JSON.parse( localStorage.getItem('token'));
  var token=decrpyt.token;

  const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
  
  return (Math.floor((new Date).getTime() / 1000)) >= expiry;
}
intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  // if(!req.url.includes("CheckToken")){

  if(localStorage.getItem('token')!=null)
  {
    if (this.tokenExpired()) {
      localStorage.clear();
      this.router.navigate(['/home']);
      return;
    }
  }

  
    this.showLoader();
  // }
  return next.handle(req).pipe(tap((event: HttpEvent<any>) => { 
    if (event instanceof HttpResponse) {
      this.onEnd();
    }
  },
    (err: any) => {
     debugger;
     console.log(err);
     if (err.status === 401) {
      this.onEnd();
      this.router.navigate(['/home']);
      this.toster.error(err.error.Message ? err.error.Message : err.message ,"Error");
  }
 else if (err.status === 0) {
    this.onEnd();
    localStorage.removeItem("localid");
  localStorage.removeItem("token");
  localStorage.removeItem("moduleid");
  localStorage.removeItem("isLoggedIn");
  this.router.navigate(['/home']);
  //this.Service.isLoggedIn=false;
    this.router.navigate(['/home']);
    this.toster.error(err.error.Message ? err.error.Message : err.message ,"Error");
}
  else
  {
      this.onEnd();
      this.toster.error(err.error.Message ? err.error.Message : err.message ,"Error");
  }
  }));
}
private onEnd(): void {
  this.hideLoader();
}
private showLoader(): void {
  this.loaderService.show();
}
private hideLoader(): void {
  this.loaderService.hide();
}


}